export const paginationChunks = ({ array, chunkSize }) => {
  const chunks = []
  for (let i = 0; i < array?.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize))
  }

  return chunks.length === 0 ? [[]] : chunks
}
